<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">알림톡 발송</span>
            <span class="txt">센터 내 전자계약 서류 알림톡 발송내역과 템플릿을 관리할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-tab">
                <button @click="onClickRouter('/madmin/noti/basic')">기본정보</button>
                <button @click="onClickRouter('/madmin/noti/talk')">알림톡 발송내역</button>
                <button class="on">템플릿 관리</button>
                <button @click="onClickRouter('/madmin/noti/status')">센터별 발송현황</button>
            </div>
            <div class="rectangle-box contract-send" style="margin-top: 30px; overflow-x: auto">
                <div style="display: flex; width: max-content">
                    <div
                        style="width: calc((100vw - 224px - 20px - 20px - 20px - 20px) / 4)"
                        v-for="(item, index) in templateInfo"
                        :key="index"
                    >
                        <div class="contract-send-item">
                            <div class="general-input-component" style="margin-top: 0; justify-content: space-between">
                                <div class="flex-center">
                                    <div
                                        class="template-item-status"
                                        :class="`${
                                            item.status == 'R'
                                                ? 'reviewing'
                                                : item.status == 'Y'
                                                ? 'approval'
                                                : item.status == 'N'
                                                ? 'reject'
                                                : ''
                                        }`"
                                    >
                                        {{
                                            item.status == 'R'
                                                ? '심사중'
                                                : item.status == 'Y'
                                                ? '승인'
                                                : item.status == 'N'
                                                ? '반려'
                                                : '대기'
                                        }}
                                    </div>
                                    <div
                                        v-show="item.status == 'N'"
                                        style="
                                            color: #f64444;
                                            padding-left: 5px;
                                            text-decoration: underline;
                                            cursor: pointer;
                                        "
                                        @click="confirmReason(index)"
                                    >
                                        사유확인
                                    </div>
                                </div>
                                <div class="line flex-center">
                                    <div class="template-item-use">사용여부</div>
                                    <div class="line-wrap">
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    :id="`${'check-sms-' + index}`"
                                                    type="checkbox"
                                                    v-model="templateInfo[index].useYn"
                                                />
                                                <label :for="`${'check-sms-' + index}`"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="general-input-component template">
                                <span class="input-title">
                                    템플릿 제목
                                    <span class="imp"></span>
                                </span>
                            </div>
                            <input
                                v-model="templateInfo[index].title"
                                class="message-link"
                                placeholder="템플릿 제목 입력"
                                type="text"
                            />
                            <div class="flex-start" style="margin-top: 10px">
                                <div>머리말</div>
                                <div class="com-check desc-right-check">
                                    <input
                                        :id="`${'check-preface-' + index}`"
                                        v-model="templateInfo[index].preface"
                                        type="checkbox"
                                    />
                                    <label :for="`${'check-preface-' + index}`"></label>
                                </div>
                                <div>꼬리말</div>
                                <div class="com-check desc-right-check">
                                    <input
                                        :id="`${'check-footer-' + index}`"
                                        v-model="templateInfo[index].footer"
                                        type="checkbox"
                                    />
                                    <label :for="`${'check-footer-' + index}`"></label>
                                </div>
                            </div>
                            <div class="general-input-component">
                                <span class="input-title">메시지 내용</span>
                            </div>
                            <textarea
                                v-model="templateInfo[index].content"
                                class="com-textarea resize-none contract-message-content"
                                maxlength="2000"
                                placeholder="메시지 내용입력"
                            ></textarea>
                            <div class="content-count">
                                {{ templateInfo[index].content ? templateInfo[index].content.length : 0 }} / 2000byte
                            </div>
                            <div class="general-input-component">
                                <span class="input-title">메시지 버튼</span>
                            </div>
                            <div class="general-input-component" style="margin-top: 5px">
                                <div class="com-radio">
                                    <input
                                        type="radio"
                                        :name="`${'template-message-' + index}`"
                                        :id="`${'template-not-used-' + index}`"
                                        :value="false"
                                        v-model="templateInfo[index].messageButton"
                                        @change="onChangeMessageButton(index)"
                                    />
                                    <label :for="`${'template-not-used-' + index}`" class="label-black">사용안함</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        type="radio"
                                        :name="`${'template-message-' + index}`"
                                        :id="`${'template-link-' + index}`"
                                        :value="true"
                                        v-model="templateInfo[index].messageButton"
                                        @change="onChangeMessageButton(index)"
                                    />
                                    <label :for="`${'template-link-' + index}`" class="label-black">링크</label>
                                </div>
                            </div>
                            <input
                                v-model="templateInfo[index].buttonName"
                                maxlength="8"
                                class="message-link"
                                placeholder="내용확인 및 서명하기"
                                type="text"
                                :style="`${!templateInfo[index].messageButton ? 'visibility: hidden;' : ''}`"
                            />
                            <div
                                class="message-link"
                                style="display: flex"
                                :style="`${!templateInfo[index].messageButton ? 'visibility: hidden;' : ''}`"
                            >
                                <input
                                    v-model="templateInfo[index].linkMobile"
                                    style="flex: 1"
                                    placeholder="www.url.kr"
                                    type="text"
                                />
                                <button
                                    class="com-btn border-button line-blind"
                                    @click="onCheckConnect(index)"
                                    :disabled="
                                        templateInfo[index].linkMobile == '' || templateInfo[index].linkMobile == null
                                    "
                                >
                                    연결확인
                                </button>
                            </div>
                            <input
                                v-model="templateInfo[index].linkPC"
                                class="message-link"
                                placeholder="www.url.kr"
                                type="text"
                                :style="`${!templateInfo[index].messageButton ? 'visibility: hidden;' : ''}`"
                            />
                            <div class="message-link" style="display: flex; margin-top: 25px">
                                <button
                                    class="com-btn deep-red"
                                    style="flex: 1; margin-right: 10px"
                                    @click="onDelete(index)"
                                >
                                    삭제
                                </button>
                                <button class="com-btn" style="flex: 1" @click="onModify(index)">
                                    {{ templateInfo[index].id == 0 ? '저장' : '수정' }}
                                </button>
                            </div>
                <div v-if='item.status == "R"' class='message-link' style='display: flex; margin-top: 10px;'>
                                <button class="com-btn blue" style="width: 100%" @click="onReviewRequest(index)">
                                    심사요청
                                </button>
                            </div>
                        </div>
                    </div>
                    <div style="width: calc((100vw - 224px - 20px - 20px - 20px - 20px) / 4)">
                        <div class="contract-send-item flex-center template-add" @click="onAdd()">
                            <div style="text-align: center">
                                <img src="/img/icons/ic_big_plus.png" style="width: 15px" />
                                <div class="add-title">추가</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { Utils } from '@/assets/js/utils';
import paymentApi from '@/assets/js/paymentApi';

export default {
    name: 'notiTemplate',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
    },
    props: {},
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.init();
    },
    data() {
        return {
            isLoading: false,
            templateInfo: [],
        };
    },
    methods: {
        // 초기화
        async init() {
            this.isLoading = true;

            this.getTemplates();

            this.isLoading = false;
        },

        onCheckConnect(index) {
            const linkUrl = this.templateInfo[index].linkMobile;

            if (linkUrl == '') {
                alert('모바일 url 링크를 입력해 주세요.');
                return;
            }

            let link = document.createElement('a');
            link.href = linkUrl;
            link.target = '_blank';
            link.click();
        },

        async getTemplates(cb = null) {
            try {
                const { data } = await api.get(`/admin/api/center/noti/talk/template/0`);
                this.templateInfo = data;

                cb && cb();
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        async onDelete(index) {
            const template = this.templateInfo[index];

            try {
                if (!confirm('템플릿을 삭제하시겠습니까?')) {
                    return;
                }

                if (template.id == 0) {
                    this.templateInfo.splice(index, 1);

                    alert('템플릿이 삭제되었습니다.');
                } else {
                    const { data } = await api.delete(`/admin/api/center/noti/talk/template/${template.id}`);

                    if (data) {
                        alert('템플릿이 삭제되었습니다.');

                        this.getTemplates();
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },

        async onChangeMessageButton(index) {
            const template = this.templateInfo[index];
            if (!template.messageButton) {
                this.templateInfo[index].buttonName = '';
                this.templateInfo[index].linkMobile = '';
                this.templateInfo[index].linkPC = '';
            }
        },

        async onModify(index, cb = null) {
            const template = this.templateInfo[index];

            if (template.title == '') {
                alert('템플릿 제목을 입력해 주세요.');
                return;
            }
            if (template.content == '') {
                alert('템플릿 내용을 입력해 주세요.');
                return;
            }

            if (template.messageButton) {
                if (template.messageButton == '') {
                    alert('버튼명을 입력해 주세요.');
                    return;
                }
                if (template.linkMobile == '') {
                    alert('모바일 링크 url을 입력해 주세요.');
                    return;
                }
                if (template.linkPC == '') {
                    alert('PC 링크 url을 입력해 주세요.');
                    return;
                }
            }

            try {
                if (cb == null) {
                    if (template.id == 0) {
                        if (!confirm('템플릿을 등록하시겠습니까?')) {
                            return;
                        }
                    } else {
                        if (!confirm('템플릿을 수정하시겠습니까?')) {
                            return;
                        }
                    }
                } else {
                    if (!confirm('심사 요청하시겠습니까?')) {
                        return;
                    }
                }

                const { data } = await api.post(`/admin/api/center/noti/talk/template`, template);

                if (data) {
                    if (cb == null) {
                        if (template.id == 0) {
                            alert('템플릿이 등록되었습니다.');

                            if (data.length > 0) {
                                this.templateInfo[index].id = data[0].id;
                            }
                        } else {
                            alert('템플릿이 변경되었습니다.');
                        }
                    }

                    cb && cb();
                }
            } catch (error) {
                console.log(error);
            }
        },

        onReviewRequest(index) {
            this.onModify(index, async () => {
                // await paymentApi.post(`/admin/api/kakaotalk/link/templates/${this.centerId}`, `${this.templateInfo[index].id}`);
                // const { data } = await api.put(`/admin/api/center/noti/talk/template/request/${this.templateInfo[index].id}`);
                // if (data) {
                //     alert("템플릿 검수를 요청했습니다.")
                // }
                const params = {
                    title: this.templateInfo[index].title,
                    content: this.templateInfo[index].content,
                    notiTemplateId: this.templateInfo[index].id,
                };

                await paymentApi
                    .post(`/admin/api/kakaotalk/create/noti_template`, params)
                    .then((response) => {
                        alert(response.data.inspection.message);
                        location.reload();
                    })
                    .catch((error) => {
                        console.error(error);
                        alert(error.response.data.error.resultMsg);
                    });
            });
        },

        onAdd() {
            this.templateInfo.push({
                id: 0,
                useYn: false,
                content: '',
                messageButton: true,
                preface: false,
                footer: false,
                buttonName: '',
                linkMobile: '',
                linkPC: '',
            });
        },

        // 페지 이동
        onClickRouter(path, menu = '', eventNum = '') {
            this.$router.push({
                path: `${path}`,
            });
        },

        confirmReason(index) {
            if (this.templateInfo[index].rejectReason == null) {
                alert('사유 없음');
            } else {
                alert(this.templateInfo[index].rejectReason);
            }
        },
    },
};
</script>
<style lang="scss"></style>
